export default {
  getSupplier: (state) => state.supplier,
};
